import { Vue as _Vue } from 'vue-property-decorator'
import DataService from '../../services/data'

export function DataServicePlugin(Vue: typeof _Vue, options?: any) {
    Vue.prototype.$dataService = DataService
}